import { GET_FILE_LIST, SHOW_SPINNER, HIDE_SPINNER, SHOW_NOTIFICATION } from '../types';
import api from '../../api';
import sessionErrHandler from './sessionErrHandler';

export const getFileList = (id) => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieram listę plików'});
  if (id === undefined) {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: 'Błąd aplikacji 500:1', type: 'error' }
    });
    return;
  }
  let response;
  try {
    response = await api.get(`/wmd/file?courseId=${id}`, { withCredentials: true });
    if (response.status === 200) {
      dispatch({ type: GET_FILE_LIST, files: { id, files: response.data }});
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd podczas pobierania listy plików', type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas pobierania listy plików', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });
}
